export default "__VITE_ASSET__Ct4$WJ_M__"